<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>

<div class="container">
  <div class="sub-title">
    {{ 'invite-list.title' | translate }}
  </div>
@for (item of invites(); track item.id) {
    <div class="item-container">
      <div class="info">
        <div class="row">
          <mat-icon>person</mat-icon>
          <span class="name">{{item.first_name + ' ' + item.last_name}}</span>
        </div>
        <div class="row">
          <mat-icon>mail</mat-icon>
          <span>{{item.email}}</span>
        </div>
        @if (item.phone_number) {
          <div class="row">
            <mat-icon>phone</mat-icon>
            <span>{{item.phone_number | phoneNumber}}</span>
          </div>
        }
        @if (item.expires_at) {
          <div class="row">
            <mat-icon>calendar_today</mat-icon>
            <span>{{item.expires_at | date: 'dd/MM/yyyy'}}</span>
          </div>
        }        
      </div>
      @if (item.token) {
        <div class="invite-link">
          <mat-icon (click)="copyToClipboard(item.token)">link</mat-icon>
        </div>
      }         
    </div>
}
</div>
